import React from "react";

export const MetadataTags: FC<MetadataTags> = ({ title, description, imageUrl }) => {
  //someday we can do this smarter
  const currentUrl = window.location.href.split("?")[0];

  return (
    <>
      <title>{title}</title>
      <link rel="canonical" href={currentUrl} />
      <meta name="description" content={description} />

      {/* opengraph stuff */}
      <meta name="og:url" content={currentUrl} />
      <meta name="og:title" content={title || "Tennr"} />
      <meta name="og:description" content={description} />
      <meta name="og:type" content="website" />
      <meta name="og:image" content={imageUrl || "https://tennr.com/share_cards/sharecard.png"} />

      {/* twitter stuff, mostly because i believe linkedin uses it */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title|| "Tennr"} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl|| "/img/sharecard.png"} />
    </>
  );
};
